unit PrepareOperationNetItemType;
{

/* Initial. */

}
interface

type
  TPrepareOperationNetItemType = class
  private
    fPrepareOperationNetKey: String;
    fPrepareOperationName: String;
    fNetName: String;
    fAmountInPrepareOperation: Byte;
  public
    property PrepareOperationNetKey: String read fPrepareOperationNetKey;
    property PrepareOperationName: String read fPrepareOperationName;
    property NetName: String read fNetName;
    property AmountInPrepareOperation: Byte read fAmountInPrepareOperation;
  end;

implementation

end.

